import React, { useRef, useEffect } from 'react';
import { components, } from 'react-select';
import { Scrollbar } from 'react-scrollbars-custom';
import AvatarRole from '../PermissionsList/AvatarRole';
import Remove from '../../assets/icons/item_remove.svg';
import { st, classes } from './SearchEntity.st.css';
import { Spinner } from 'wix-ui-tpa';
import { DEFAULT_ROWS_NUMBER, MENU_SCROLLBAR_HEIGHT, SPACED_ROW_HEIGHT, SPACING, } from './constants';
const menuScrollbarStyle = {
    width: '100%',
    maxHeight: `${MENU_SCROLLBAR_HEIGHT}px`,
};
const valueContainerScrollbarStyle = {
    width: '120%',
    maxHeight: `${SPACED_ROW_HEIGHT * DEFAULT_ROWS_NUMBER + SPACING}px`,
};
export const NoOptionsMessage = (props) => {
    return (React.createElement(components.NoOptionsMessage, { ...props, className: st(classes.no_options) }));
};
export const LoadingMessage = (props) => {
    return (React.createElement("div", { ...props.innerProps, style: props.getStyles('loadingMessage', props), className: st(classes.loading_message) },
        React.createElement("span", { className: st(classes.spinner) },
            React.createElement(Spinner, { diameter: 16, className: st(classes.blackSpinner) })),
        props.children));
};
function getLength(options) {
    return options.reduce((acc, curr) => {
        if (curr.options) {
            return acc + getLength(curr.options);
        }
        return acc + 1;
    }, 0);
}
export const Menu = (resultString) => {
    return (props) => {
        const { isLoading } = props.selectProps;
        const optionsLength = getLength(props.options) - props.getValue().length;
        const parsedResults = resultString.replace('{0}', `${optionsLength}`);
        return (React.createElement(Scrollbar, { native: true, translateContentSizeYToHolder: true, style: menuScrollbarStyle, noScrollX: true },
            !isLoading && (React.createElement("div", { role: "alert", className: "sr-only" }, parsedResults)),
            React.createElement(components.Menu, { ...props }, props.children)));
    };
};
export const MultiValueRemove = (removeMessage) => {
    return (props) => {
        const parsedResults = removeMessage.replace('{0}', `${props.data.label}`);
        return (React.createElement(components.MultiValueRemove, { ...props },
            React.createElement(Remove, { className: st(classes.item_remove), "aria-label": parsedResults, tabIndex: 0 })));
    };
};
export const ValueContainer = (props) => {
    const scrollComponent = useRef(null);
    useEffect(() => {
        scrollComponent.current && scrollComponent.current.scrollToBottom();
    });
    if (props.hasValue) {
        return (React.createElement(Scrollbar, { translateContentSizeYToHolder: true, style: valueContainerScrollbarStyle, noScrollX: true, ref: scrollComponent },
            React.createElement(components.ValueContainer, { ...props }, props.children)));
    }
    return (React.createElement(components.ValueContainer, { ...props }, props.children));
};
export const Option = (props) => {
    const { role, description, icon } = props.data;
    const avatarData = {
        role,
        description,
        icon,
        displayDescription: true,
        roleID: props.data.id,
    };
    const { isFocused } = props;
    return (React.createElement(components.Option, { ...props, className: st(isFocused ? classes.focusedOption : classes.unfocusedOption) },
        React.createElement(AvatarRole, { ...avatarData })));
};
//# sourceMappingURL=SearchReplacmentsComponents.js.map